import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ConnectorAction } from "stores/Connector/ConnectorAction";

const mapStateToProps = (state) => {
  return {
    postConnectorList: state.ConnectorData.postConnectorList,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      postConnectorData: ConnectorAction.postConnectorData,
    },
    dispatch
  );

const AddConnectorTypeStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default AddConnectorTypeStore;
